module.exports = __webpack_public_path__ + "img/sec5_14.6abe38ce.jpg";